
<div *ngIf="currentView === 'prompt'"
     class="flex flex-column justify-content-center align-items-center w-full">
    <h2 class="text-center">Overthinking it?</h2>

    <div class="w-full mx-auto mt-2">
        <p-button
            label="Press this"
            styleClass="learn-btn w-full"
            severity="info"
            (onClick)="onReveal()"
        ></p-button>
    </div>
</div>

<div *ngIf="currentView === 'reveal'"
     class="relative w-full flex align-items-center justify-content-center">
    <button
        class="close-button absolute flex align-items-center justify-content-center border-circle bg-transparent border-none cursor-pointer z-5 text-white"
        style="top: 12px; right: 12px; width: 36px; height: 36px; outline: none"
        (click)="onClose()"
        aria-label="Close"
        tabindex="-1"
    >
        <i class="ph ph-x text-2xl"></i>
    </button>

    <video
        [src]="videoUrl"
        class="w-full block border-round-lg"
        style="height: auto"
        autoplay
        loop
        muted
        playsinline
    ></video>
</div>
